import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'ScreenBranch',
    component: () => import('../views/ScreenBranch.vue')
  },
  {
    path: '/memberAuthentication',
    name: 'MemberAuthentication',
    component: () => import('../views/MemberAuthentication.vue')
  },
  {
    path: '/memberMenu',
    name: 'MemberMenu',
    component: () => import('../views/MemberMenu.vue')
  },
  {
    path: '/memberRegistMenu',
    name: 'MemberRegistMenu',
    component: () => import('../views/MemberRegistMenu.vue')
  },
  {
    path: '/memberRegist',
    name: 'MemberRegist',
    component: () => import('../views/MemberRegist.vue')
  },
  {
    path: '/qrcode',
    name: 'Qrcode',
    component: () => import('../views/Qrcode.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
